import algoliasearch from 'algoliasearch/lite';
import React from 'react';
import {
    InstantSearch,
    Configure,
    ToggleRefinement, DynamicWidgets,
    useInstantSearch
} from 'react-instantsearch-hooks-web';
import Util from '../../../../../src/js/Util';
import {
    Filters,
    Results,
    Trigger,
} from './components';

import './App.css';
import '../scss/App.scss';
import {createInsightsMiddleware} from "instantsearch.js/es/middlewares";

let indexName, searchClient;

const refinementsObj = ( filters, current_language, filters_with_lang ) => {
    let obj = {};
    filters.forEach( f => {
        let key = f.filter_name;
        if( filters_with_lang.includes(f.filter_name) ) {
            key = `${f.filter_name}.${current_language}`;
        }

        let options = [];

        f[`filter_options_${f.filter_name}`].forEach(o => {
            options.push(Util.translate(o));
        });

        obj[key] = options;
    } );

    return obj;
};

export class App extends React.Component<any, any> {

    constructor(props) {
        super(props);

        const { data_api_app_id, data_api_key, data_api_index_name } = this.validateSetup( this.props.config );

        const details_button = this.props.config.details_button === 'yes';
        const default_filter = 'hide_filters' in this.props.pageConfig || 'hide_filters' in this.props.config ? null : 'series';
        const app_filters = this.props.config.app_filters || [];
        let checked_filters = this.props.checkedFilterConfig || [];
        let old_checked_filters = this.props.pageConfig.checked_filters || this.props.config.checked_filters;
        const include_hidden = 'include_hidden' in this.props.config && this.props.config.include_hidden === 'yes' || false;
        const current_language = SUMA.language || 'en_US';
        const filters_with_lang = [];
        filters_with_lang.push('country','metal','mint_status','series','year');
        checked_filters.push(
            {
                filter_name: 'post_status',
                filter_options_post_status: ['publish']
            },{
                filter_name: '_exclude_from_search',
                filter_options__exclude_from_search: ['no']
            }
        )

        indexName = data_api_index_name || '';
        searchClient = algoliasearch(
            data_api_app_id,
            data_api_key
        );

        this.state = {
            activeFilter: default_filter,
            currentLanguage: current_language,
            checkedFilters: checked_filters,
            defaultRefinements: refinementsObj( checked_filters || [], current_language, filters_with_lang ),
            details_button: details_button,
            filters: app_filters,
            filters_with_lang : filters_with_lang,
            filteringIsOpen: true,  // keep this open for now; client doesn't want refinements closed
            filterModalOpen: false,
            hitsPerPage: {
                items: [
                    { label: Util.translate('Show 18 Results'), value: 18, default: true },
                    { label: Util.translate('Show 36 Results'), value: 36 },
                ],
            },
            indexName,
            query: this.props.config.app_search || null,
            includeHidden: include_hidden
        };

        this.hideFilter = this.hideFilter.bind(this);
        this.hideFilterModal = this.hideFilterModal.bind(this);
        this.toggleFilter = this.toggleFilter.bind(this);
        this.toggleFiltering = this.toggleFiltering.bind(this);
        this.toggleFilterModal = this.toggleFilterModal.bind(this);

    }

    validateSetup( config ) {

        let { data_api_app_id, data_api_key, data_api_index_name } = config;

        if ( data_api_index_name === undefined
            || data_api_app_id === undefined
            || data_api_key === undefined ) {

            // Check for global settings
            if ( undefined !== window.algolia ) {
                data_api_app_id = window.algolia.application_id;
                data_api_key = window.algolia.search_api_key;
                data_api_index_name = window.algolia.indices.posts_product.name;
            }
        }

        return { data_api_app_id, data_api_key, data_api_index_name };
    }

    hideFilter() {
        this.setState( { activeFilter: null } );
    }

    hideFilterModal() {
        this.setState( { filterModalOpen: false } );
    }

    toggleFilter( attribute ) {
        this.setState( { activeFilter: attribute } );
    }

    toggleFiltering() {
        this.setState( prevState => ( {
            filteringIsOpen: !prevState.filteringIsOpen
        } ) );
    }

    toggleFilterModal() {
        this.setState( prevState => ({ filterModalOpen: !prevState.filterModalOpen }) );
    }

    render() {
        const query = this.state.query || '';

        return (
            <InstantSearch
                searchClient={searchClient}
                indexName={indexName}
                routing={true}
                middleware={[this.analyticsMiddleware]}
                initialUiState={{
                    [indexName]: {
                        query,
                        refinementList: this.state.defaultRefinements,
                        toggle: {
                            visible: this.state.includeHidden === false
                        }
                    },
                }}
            >
                <Configure query={query} maxValuesPerFacet={100} />

                <Analytics/>

                <div className={`algolia-catalog${this.state.filterModalOpen ? ' filter-modal-open' : ''}`}>
                    <Trigger toggleFilter={this.toggleFilter} toggleFiltering={this.toggleFiltering} toggleFilterModal={this.toggleFilterModal} {...this.state} />
                    <Filters hideFilter={this.hideFilter} hideFilterModal={this.hideFilterModal} toggleFilter={this.toggleFilter} toggleFilterModal={this.toggleFilterModal} {...this.state} />
                    <Results hideFilterModal={this.hideFilterModal} toggleFilter={this.toggleFilter} toggleFiltering={this.toggleFiltering} {...this.state} />
                    <ToggleRefinement attribute="visible" className="filter-hidden" />

                    <div className="algolia-filters-overlay"></div>
                </div>

            </InstantSearch>
        );
    }

}

const Analytics = () => {
    const { results } = useInstantSearch();
    const [hasFired, setHasFired] = React.useState(false);

    React.useEffect(() => {
        if (results && results.hits && results.hits.length > 0 && !hasFired) {

            // Filter product data to include specific attributes
            const filteredHits = results.hits.map(hit => ({
                item_id: hit.objectID?.toString().replace(/-0$/, ''), // remove trailing -0 if present
                item_name: hit.post_title.en_US || hit.post_title,
                price: hit.price,
                quantity: 1
            }));

            let id =  jQuery('.algolia-catalog').closest('[data-id]').attr('data-id');

            // Format analytics data
            const analyticsData = {
                item_list_id: 'algolia-catalog-' + (id),
                item_list_name: window.location.pathname,
                items: filteredHits,
            };

            // Trigger analytics event
            jQuery('body').trigger('product-list/viewed', analyticsData);

            setHasFired(true);
        }
    }, [results, hasFired]);

    return null; // No UI rendering
};
